let log = {
    title: "Operation record",
    columns: {
      appUsername: "Login user name",
        logTime: "Operation time",
        actionType: "Operation type",
        descp: "Operation content",
        device: "Equipment type",
        actionObject:"Operation object",
        browser: "Browser",
        location: "Login location",
        ip: "Client IP",
      resultReason:'Result reason',
        result: "Operation result"
    },
    type: "Operation type",
    result: "Operation result",
    time: "Operation time",
    startTime:"Operation start time",
    endTime:"Operation end time",
    selectType: {
        type01: 'All',
        type02: 'login',
        type03: 'Logout',
        type04: 'bind',
        type05: 'modify',
        type06: 'reset',
        type07: 'unbind',
        type08: 'activate',
        type09: 'visit',
        type10: 'send',
        type11: 'add',
        type12: 'cancel',
        type13:"delete",
        type15:"Authentication",
        type16:"Push authentication",
        type17:"Binding",
        type18:"Unbinding",
        type19:"Synchronization",
        type20:"Activation",
        type21:"Deactivation",
        type22:"Scan authentication",
    },
    resultType: {
        label01: "All",
        label02: "Fail",
        label03: "Success",
    },
    details: "Details of Operation Records"
}

export default log
